import { LRParser } from '@lezer/lr';
import { styleTags, tags } from '@lezer/highlight';

// This file was generated by lezer-generator. You probably shouldn't edit it.
const inf$1 = 161,
  nan$1 = 162,
  Bool$1 = 1,
  Ignoring$1 = 2,
  On$1 = 3,
  GroupLeft$1 = 4,
  GroupRight$1 = 5,
  Offset$1 = 6,
  Atan2$1 = 7,
  Avg$1 = 8,
  Bottomk$1 = 9,
  Count$1 = 10,
  CountValues$1 = 11,
  Group$1 = 12,
  Max$1 = 13,
  Min$1 = 14,
  Quantile$1 = 15,
  LimitK$1 = 16,
  LimitRatio$1 = 17,
  Stddev$1 = 18,
  Stdvar$1 = 19,
  Sum$1 = 20,
  Topk$1 = 21,
  By$1 = 22,
  Without$1 = 23,
  And$1 = 24,
  Or$1 = 25,
  Unless$1 = 26,
  Start$1 = 27,
  End$1 = 28;

// Copyright 2021 The Prometheus Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.


const keywordTokens = {
    inf: inf$1,
    nan: nan$1,
    bool: Bool$1,
    ignoring: Ignoring$1,
    on: On$1,
    group_left: GroupLeft$1,
    group_right: GroupRight$1,
    offset: Offset$1,
};

const specializeIdentifier = (value, stack) => {
    return keywordTokens[value.toLowerCase()] || -1;
};

const contextualKeywordTokens = {
    avg: Avg$1,
    atan2: Atan2$1,
    bottomk: Bottomk$1,
    count: Count$1,
    count_values: CountValues$1,
    group: Group$1,
    max: Max$1,
    min: Min$1,
    quantile: Quantile$1,
    limitk: LimitK$1,
    limit_ratio: LimitRatio$1,
    stddev: Stddev$1,
    stdvar: Stdvar$1,
    sum: Sum$1,
    topk: Topk$1,
    by: By$1,
    without: Without$1,
    and: And$1,
    or: Or$1,
    unless: Unless$1,
    start: Start$1,
    end: End$1,
};

const extendIdentifier = (value, stack) => {
    return contextualKeywordTokens[value.toLowerCase()] || -1;
};

// Copyright 2022 The Prometheus Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.


const promQLHighLight = styleTags({
    LineComment: tags.comment,
    LabelName: tags.labelName,
    StringLiteral: tags.string,
    NumberDurationLiteral: tags.number,
    NumberDurationLiteralInDurationContext: tags.number,
    Identifier: tags.variableName,
    'Abs Absent AbsentOverTime Acos Acosh Asin Asinh Atan Atanh AvgOverTime Ceil Changes Clamp ClampMax ClampMin Cos Cosh CountOverTime DaysInMonth DayOfMonth DayOfWeek DayOfYear Deg Delta Deriv Exp Floor HistogramAvg HistogramCount HistogramFraction HistogramQuantile HistogramSum DoubleExponentialSmoothing Hour Idelta Increase Irate LabelReplace LabelJoin LastOverTime Ln Log10 Log2 MaxOverTime MinOverTime Minute Month Pi PredictLinear PresentOverTime QuantileOverTime Rad Rate Resets Round Scalar Sgn Sin Sinh Sort SortDesc SortByLabel SortByLabelDesc Sqrt StddevOverTime StdvarOverTime SumOverTime Tan Tanh Time Timestamp Vector Year':
        tags.function(tags.variableName),
    'Avg Bottomk Count Count_values Group LimitK LimitRatio Max Min Quantile Stddev Stdvar Sum Topk': tags.operatorKeyword,
    'By Without Bool On Ignoring GroupLeft GroupRight Offset Start End': tags.modifier,
    'And Unless Or': tags.logicOperator,
    'Sub Add Mul Mod Div Atan2 Eql Neq Lte Lss Gte Gtr EqlRegex EqlSingle NeqRegex Pow At': tags.operator,
    UnaryOp: tags.arithmeticOperator,
    '( )': tags.paren,
    '[ ]': tags.squareBracket,
    '{ }': tags.brace,
    '⚠': tags.invalid,
});

// This file was generated by lezer-generator. You probably shouldn't edit it.
const spec_Identifier = {__proto__:null,absent_over_time:341, absent:343, abs:345, acos:347, acosh:349, asin:351, asinh:353, atan:355, atanh:357, avg_over_time:359, ceil:361, changes:363, clamp:365, clamp_max:367, clamp_min:369, cos:371, cosh:373, count_over_time:375, days_in_month:377, day_of_month:379, day_of_week:381, day_of_year:383, deg:385, delta:387, deriv:389, exp:391, floor:393, histogram_count:395, histogram_fraction:397, histogram_quantile:399, histogram_stddev:401, histogram_stdvar:403, histogram_sum:405, histogram_avg:407, double_exponential_smoothing:409, hour:411, idelta:413, increase:415, info:417, irate:419, label_replace:421, label_join:423, last_over_time:425, ln:427, log10:429, log2:431, mad_over_time:433, max_over_time:435, min_over_time:437, ts_of_max_over_time:439, ts_of_min_over_time:441, ts_of_last_over_time:443, minute:445, month:447, pi:449, predict_linear:451, present_over_time:453, quantile_over_time:455, rad:457, rate:459, resets:461, round:463, scalar:465, sgn:467, sin:469, sinh:471, sort:473, sort_desc:475, sort_by_label:477, sort_by_label_desc:479, sqrt:481, stddev_over_time:483, stdvar_over_time:485, sum_over_time:487, tan:489, tanh:491, timestamp:493, time:495, vector:497, year:499};
const parser = LRParser.deserialize({
  version: 14,
  states: "9tOYQPOOO'}QPOOOOQO'#C|'#C|O(SQPO'#C{Q(_QQOOOOQO'#De'#DeO(YQPO'#DdOOQO'#F]'#F]O)lQPO'#FbOYQPO'#F_OYQPO'#FaO0jQSO'#FdO0uQQO'#FcOOQO'#Fc'#FcOOQO'#Fw'#FwOOQO'#Df'#DfOOQO'#Dh'#DhOOQO'#Di'#DiOOQO'#Dj'#DjOOQO'#Dk'#DkOOQO'#Dl'#DlOOQO'#Dm'#DmOOQO'#Dn'#DnOOQO'#Do'#DoOOQO'#Dp'#DpOOQO'#Dq'#DqOOQO'#Dr'#DrOOQO'#Ds'#DsOOQO'#Dt'#DtOOQO'#Du'#DuOOQO'#Dv'#DvOOQO'#Dw'#DwOOQO'#Dx'#DxOOQO'#Dy'#DyOOQO'#Dz'#DzOOQO'#D{'#D{OOQO'#D|'#D|OOQO'#D}'#D}OOQO'#EO'#EOOOQO'#EP'#EPOOQO'#EQ'#EQOOQO'#ER'#EROOQO'#ES'#ESOOQO'#ET'#ETOOQO'#EU'#EUOOQO'#EV'#EVOOQO'#EW'#EWOOQO'#EX'#EXOOQO'#EY'#EYOOQO'#EZ'#EZOOQO'#E['#E[OOQO'#E]'#E]OOQO'#E^'#E^OOQO'#E_'#E_OOQO'#E`'#E`OOQO'#Ea'#EaOOQO'#Eb'#EbOOQO'#Ec'#EcOOQO'#Ed'#EdOOQO'#Ee'#EeOOQO'#Ef'#EfOOQO'#Eg'#EgOOQO'#Eh'#EhOOQO'#Ei'#EiOOQO'#Ej'#EjOOQO'#Ek'#EkOOQO'#El'#ElOOQO'#Em'#EmOOQO'#En'#EnOOQO'#Eo'#EoOOQO'#Ep'#EpOOQO'#Eq'#EqOOQO'#Er'#ErOOQO'#Es'#EsOOQO'#Et'#EtOOQO'#Eu'#EuOOQO'#Ev'#EvOOQO'#Ew'#EwOOQO'#Ex'#ExOOQO'#Ey'#EyOOQO'#Ez'#EzOOQO'#E{'#E{OOQO'#E|'#E|OOQO'#E}'#E}OOQO'#FO'#FOOOQO'#FP'#FPOOQO'#FQ'#FQOOQO'#FR'#FROOQO'#FS'#FSOOQO'#FT'#FTOOQO'#FU'#FUOOQO'#FV'#FVOOQO'#FW'#FWOOQO'#FX'#FXOOQO'#FY'#FYQOQPOOO2`QPO'#C}O2eQPO'#DSO(YQPO,59gO2lQQO,59gO4YQPO,59oO4YQPO,59oO4YQPO,59oO4YQPO,59oO4YQPO,59oO;WQPO,5;uO;WQPO,5;xO;iQPO,5<VOOQO,5:O,5:OOOQO,5;w,5;wO<QQQO,5;yO<XQQO,5;{OOQO'#DQ'#DQO=oQPO'#FeO=}QPO,5<OOOQO,5<O,5<OO>ZQPO,5<OOOQO,5;},5;}O>cQSO'#DOOOQO,59i,59iOOQO,59n,59nO>nQQO,59nOOQO1G/R1G/ROOQO'#DV'#DVO2`QPO'#DWOOQO'#F{'#F{O>xQPO'#F{OYQPO1G/ZOYQPO1G/ZOYQPO1G/ZOYQPO1G/ZOYQPO1G/ZOOQO'#F['#F[OEsQPO'#F[OFOQSO1G1aOOQO1G1d1G1dOFWQPO'#F]OOQO'#Fm'#FmOOQO1G1q1G1qOFcQPO1G1qOOQO1G1e1G1eOOQO'#Ff'#FfOFhQPO,5<POFmQPO,5<UOFrQSO1G1jOF}QPO1G1jOOQO1G1j1G1jOOQO,59j,59jOGVQPO,59jOYQPO'#FpOG_QPO1G/YOOQO1G/Y1G/YOGgQPO,59rOOQO,5<g,5<gO! lQQO7+$uO! |QQO7+$uO!#bQQO7+$uO!#xQQO7+$uO!%aQQO7+$uOOQO,5;v,5;vOOQO7+&{7+&{O!%zQPO7+'QO!&RQPO7+']OOQO1G1k1G1kOOQO1G1p1G1pO!&WQPO,5<]OOQO,5<],5<]OOQO7+'U7+'UO!&lQSO7+'UOOQO-E9o-E9oO!&wQSO1G/UO!'SQPO1G/UOOQO1G/U1G/UO!'[QQO,5<[OOQO-E9n-E9nOOQO7+$t7+$tO!'fQPO1G/^OOQO<<Jl<<JlO!.ZQPO<<JlOOQO<<Jw<<JwOOQO<<Jp<<JpP!.`QSO'#FqOOQO,5<Z,5<ZOOQO7+$p7+$pO!.hQSO7+$pOOQO-E9m-E9mOOQO7+$x7+$xOOQOAN@WAN@WOOQO<<H[<<H[P!.sQSO'#Fo",
  stateData: "!.{~O$jOSmOS~OWQOXQOYQOZQO[QO]QO^QO_QO`QOaQObQOcQOdQOeQOu^O!Z[O$gVO$hVO$lXO$p_O$q`O$raO$sbO$tcO$udO$veO$wfO$xgO$yhO$ziO${jO$|kO$}lO%OmO%PnO%QoO%RpO%SqO%TrO%UsO%VtO%WuO%XvO%YwO%ZxO%[yO%]zO%^{O%_|O%`}O%a!OO%b!PO%c!QO%d!RO%e!SO%f!TO%g!UO%h!VO%i!WO%j!XO%k!YO%l!ZO%m![O%n!]O%o!^O%p!_O%q!`O%r!aO%s!bO%t!cO%u!dO%v!eO%w!fO%x!gO%y!hO%z!iO%{!jO%|!kO%}!lO&O!mO&P!nO&Q!oO&R!pO&S!qO&T!rO&U!sO&V!tO&W!uO&X!vO&Y!wO&Z!xO&[!yO&]!zO&^!{O&_!|O&`!}O&a#OO&b#PO&c#QO&eWO&fWO&gVO&jZO~O!Z#RO~Of#SOg#SO$l#TO~OU#^OV#WOh#ZOi#[Oj#ZOx#WO{#WO|#WO}#WO!O#XO!P#XO!Q#YO!R#YO!S#YO!T#YO!U#YO!V#YO$`#_O&d#]O~O$g#aO$h#aO&g#aOW$UXX$UXY$UXZ$UX[$UX]$UX^$UX_$UX`$UXa$UXb$UXc$UXd$UXe$UXu$UX!Z$UX$g$UX$h$UX$l$UX$p$UX$q$UX$r$UX$s$UX$t$UX$u$UX$v$UX$w$UX$x$UX$y$UX$z$UX${$UX$|$UX$}$UX%O$UX%P$UX%Q$UX%R$UX%S$UX%T$UX%U$UX%V$UX%W$UX%X$UX%Y$UX%Z$UX%[$UX%]$UX%^$UX%_$UX%`$UX%a$UX%b$UX%c$UX%d$UX%e$UX%f$UX%g$UX%h$UX%i$UX%j$UX%k$UX%l$UX%m$UX%n$UX%o$UX%p$UX%q$UX%r$UX%s$UX%t$UX%u$UX%v$UX%w$UX%x$UX%y$UX%z$UX%{$UX%|$UX%}$UX&O$UX&P$UX&Q$UX&R$UX&S$UX&T$UX&U$UX&V$UX&W$UX&X$UX&Y$UX&Z$UX&[$UX&]$UX&^$UX&_$UX&`$UX&a$UX&b$UX&c$UX&e$UX&f$UX&g$UX&j$UX~Os#eOu#dO&k#gO~O&jZOU$VXV$VXh$VXi$VXj$VXx$VX{$VX|$VX}$VX!O$VX!P$VX!Q$VX!R$VX!S$VX!T$VX!U$VX!V$VX$`$VX$f$VX&d$VX$n$VX$m$VX~O$l#jO~O$n#lO~PYOf#SOg#SOUoaVoahoaioajoaxoa{oa|oa}oa!Ooa!Poa!Qoa!Roa!Soa!Toa!Uoa!Voa$`oa$foa&doa$noa$moa~OP#oOQ#pOR#pOW$oPX$oPY$oPZ$oP[$oP]$oP^$oP_$oP`$oPa$oPb$oPc$oPd$oPe$oPu$oP!Z$oP$g$oP$h$oP$l$oP$p$oP$q$oP$r$oP$s$oP$t$oP$u$oP$v$oP$w$oP$x$oP$y$oP$z$oP${$oP$|$oP$}$oP%O$oP%P$oP%Q$oP%R$oP%S$oP%T$oP%U$oP%V$oP%W$oP%X$oP%Y$oP%Z$oP%[$oP%]$oP%^$oP%_$oP%`$oP%a$oP%b$oP%c$oP%d$oP%e$oP%f$oP%g$oP%h$oP%i$oP%j$oP%k$oP%l$oP%m$oP%n$oP%o$oP%p$oP%q$oP%r$oP%s$oP%t$oP%u$oP%v$oP%w$oP%x$oP%y$oP%z$oP%{$oP%|$oP%}$oP&O$oP&P$oP&Q$oP&R$oP&S$oP&T$oP&U$oP&V$oP&W$oP&X$oP&Y$oP&Z$oP&[$oP&]$oP&^$oP&_$oP&`$oP&a$oP&b$oP&c$oP&e$oP&f$oP&g$oP&j$oP~O$g#xO$h#xO&e#yO&f#yO&g#xO~Ok#}Ol#}O$gVO$hVO&e#|O&f#|O&gVO~O$n$QO~P(_Ox#WOU$TaV$Tah$Tai$Taj$Ta{$Ta|$Ta}$Ta!O$Ta!P$Ta!Q$Ta!R$Ta!S$Ta!T$Ta!U$Ta!V$Ta$`$Ta$f$Ta&d$Ta$n$Ta$m$Ta~O!V$RO$Z$RO$[$RO$]$RO~O!V$RO$Z$RO$[$RO$]$RO$m$UO&k$WO~Os$YOu#dO$n$XO~O$m$ZO$n$]O~P(_OQ#pOR#pOW$oXX$oXY$oXZ$oX[$oX]$oX^$oX_$oX`$oXa$oXb$oXc$oXd$oXe$oXu$oX!Z$oX$g$oX$h$oX$l$oX$p$oX$q$oX$r$oX$s$oX$t$oX$u$oX$v$oX$w$oX$x$oX$y$oX$z$oX${$oX$|$oX$}$oX%O$oX%P$oX%Q$oX%R$oX%S$oX%T$oX%U$oX%V$oX%W$oX%X$oX%Y$oX%Z$oX%[$oX%]$oX%^$oX%_$oX%`$oX%a$oX%b$oX%c$oX%d$oX%e$oX%f$oX%g$oX%h$oX%i$oX%j$oX%k$oX%l$oX%m$oX%n$oX%o$oX%p$oX%q$oX%r$oX%s$oX%t$oX%u$oX%v$oX%w$oX%x$oX%y$oX%z$oX%{$oX%|$oX%}$oX&O$oX&P$oX&Q$oX&R$oX&S$oX&T$oX&U$oX&V$oX&W$oX&X$oX&Y$oX&Z$oX&[$oX&]$oX&^$oX&_$oX&`$oX&a$oX&b$oX&c$oX&e$oX&f$oX&g$oX&j$oX~O$g$eO$h$eO&g$eO~O&h$fO&i$gO~O$g#aO$h#aO&g#aO~O$l$hO~Ou$iO~Ou$jO~Os#eOu#dO&k$mO~O$m$nO&k$mO~O$m$pO$n$rO~O$m$ZO$n$uO~OS$vOT$vOWzaXzaYzaZza[za]za^za_za`zaazabzaczadzaezauza!Zza$gza$hza$lza$pza$qza$rza$sza$tza$uza$vza$wza$xza$yza$zza${za$|za$}za%Oza%Pza%Qza%Rza%Sza%Tza%Uza%Vza%Wza%Xza%Yza%Zza%[za%]za%^za%_za%`za%aza%bza%cza%dza%eza%fza%gza%hza%iza%jza%kza%lza%mza%nza%oza%pza%qza%rza%sza%tza%uza%vza%wza%xza%yza%zza%{za%|za%}za&Oza&Pza&Qza&Rza&Sza&Tza&Uza&Vza&Wza&Xza&Yza&Zza&[za&]za&^za&_za&`za&aza&bza&cza&eza&fza&gza&jza~Ox#WOUwqhwqiwqjwq!Owq!Pwq!Qwq!Rwq!Swq!Twq!Uwq!Vwq$`wq$fwq&dwq$nwq$mwq~OVwq{wq|wq}wq~PNbOV#WO{#WO|#WO}#WO~PNbOV#WOx#WO{#WO|#WO}#WO!O#XO!P#XOUwqhwqiwqjwq$`wq$fwq&dwq$nwq$mwq~O!Qwq!Rwq!Swq!Twq!Uwq!Vwq~P!!^O!Q#YO!R#YO!S#YO!T#YO!U#YO!V#YO~P!!^OV#WOh#ZOj#ZOx#WO{#WO|#WO}#WO!O#XO!P#XO!Q#YO!R#YO!S#YO!T#YO!U#YO!V#YO~OUwqiwq$`wq$fwq&dwq$nwq$mwq~P!$`O&h$wO~P;WO$n$yO~O!V$RO$Z$RO$[$RO$]$RO$m$ea&k$ea~Os#eOu#dO&k$zO~Os$|Ou#dO$n$}O~O$m%OO$n$}O~O$m$da$n$da~P(_O$l#jOWziXziYziZzi[zi]zi^zi_zi`ziazibziczidzieziuzi!Zzi$gzi$hzi$pzi$qzi$rzi$szi$tzi$uzi$vzi$wzi$xzi$yzi$zzi${zi$|zi$}zi%Ozi%Pzi%Qzi%Rzi%Szi%Tzi%Uzi%Vzi%Wzi%Xzi%Yzi%Zzi%[zi%]zi%^zi%_zi%`zi%azi%bzi%czi%dzi%ezi%fzi%gzi%hzi%izi%jzi%kzi%lzi%mzi%nzi%ozi%pzi%qzi%rzi%szi%tzi%uzi%vzi%wzi%xzi%yzi%zzi%{zi%|zi%}zi&Ozi&Pzi&Qzi&Rzi&Szi&Tzi&Uzi&Vzi&Wzi&Xzi&Yzi&Zzi&[zi&]zi&^zi&_zi&`zi&azi&bzi&czi&ezi&fzi&gzi&jzi~O&h%RO~Os#eOu#dO~Os$|Ou#dO$n%SO~Os$|Ou#dO~O",
  goto: ")y$pPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP$q$}%Z%aP%jP%z$qP&T&[PPPPPPPPPPP$q&f&rP&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r&r$q'O'X$q$q$q$q'h$q't(T(]PPP(T$qP(dP(g(m(sPPPPP(zPPP)je^OXY#T#s#t#u#v#w$ZeROXY#T#s#t#u#v#w$ZQ#URR#n#VQ#k#SQ$^#pR%Q$vQ#fZQ$Y#jU$k$U$n${V$|$p%O%TQ#VRQ#`UR#n#UZ#r#W#X#Y#Z#[Y#q#W#X#Y#Z#[R$_#reUOXY#T#s#t#u#v#w$ZeTOXY#T#s#t#u#v#w$ZQ#z#]Q#{#^R$x$gd^OXY#T#s#t#u#v#w$ZR$O#_eYOXY#T#s#t#u#v#w$Zd]OXY#T#s#t#u#v#w$ZR#i[Q#hZV$l$U$n${Q$S#eT$T#f$kR$P#_Q$q$YR%P$qQ$[#mR$t$[S$V#f#hR$o$VQSOQ#bXQ#cYQ#m#TQ$`#sQ$a#tQ$b#uQ$c#vQ$d#wR$s$ZQ#s#WQ#t#XQ#u#YQ#v#ZR#w#[",
  nodeNames: "⚠ Bool Ignoring On GroupLeft GroupRight Offset Atan2 Avg Bottomk Count CountValues Group Max Min Quantile LimitK LimitRatio Stddev Stdvar Sum Topk By Without And Or Unless Start End LineComment PromQL AggregateExpr AggregateOp AggregateModifier GroupingLabels LabelName QuotedLabelName StringLiteral FunctionCallBody BinaryExpr Pow BoolModifier MatchingModifierClause Mul Div Mod Add Sub Eql Gte Gtr Lte Lss Neq FunctionCall FunctionIdentifier AbsentOverTime Identifier Absent Abs Acos Acosh Asin Asinh Atan Atanh AvgOverTime Ceil Changes Clamp ClampMax ClampMin Cos Cosh CountOverTime DaysInMonth DayOfMonth DayOfWeek DayOfYear Deg Delta Deriv Exp Floor HistogramCount HistogramFraction HistogramQuantile HistogramStdDev HistogramStdVar HistogramSum HistogramAvg DoubleExponentialSmoothing Hour Idelta Increase Info Irate LabelReplace LabelJoin LastOverTime Ln Log10 Log2 MadOverTime MaxOverTime MinOverTime TsOfMaxOverTime TsOfMinOverTime TsOfLastOverTime Minute Month Pi PredictLinear PresentOverTime QuantileOverTime Rad Rate Resets Round Scalar Sgn Sin Sinh Sort SortDesc SortByLabel SortByLabelDesc Sqrt StddevOverTime StdvarOverTime SumOverTime Tan Tanh Timestamp Time Vector Year MatrixSelector NumberDurationLiteralInDurationContext NumberDurationLiteral OffsetExpr ParenExpr SubqueryExpr UnaryExpr UnaryOp VectorSelector LabelMatchers UnquotedLabelMatcher MatchOp EqlSingle EqlRegex NeqRegex QuotedLabelMatcher StepInvariantExpr At AtModifierPreprocessors MetricName",
  maxTerm: 257,
  nodeProps: [
    ["group", -12,31,37,39,54,137,139,140,141,142,143,145,153,"Expr"]
  ],
  propSources: [promQLHighLight],
  skippedNodes: [0,29],
  repeatNodeCount: 3,
  tokenData: "4k~RwX^#lpq#lqr$ars$tst&luv'Twx'Yxy({yz)Qz{)V{|)[|})c}!O)h!O!P)o!P!Q*u!Q!R*z!R![+u![!]1O!^!_1z!_!`2X!`!a2n!b!c2{!c!}3Q!}#O3h#P#Q3m#Q#R3r#R#S3Q#S#T3w#T#o3Q#o#p4a#q#r4f#y#z#l$f$g#l#BY#BZ#l$IS$I_#l$I|$JO#l$JT$JU#l$KV$KW#l&FU&FV#l~#qY$j~X^#lpq#l#y#z#l$f$g#l#BY#BZ#l$IS$I_#l$I|$JO#l$JT$JU#l$KV$KW#l&FU&FV#l~$dQ!_!`$j#r#s$o~$oO!V~~$tO$]~~$yWu~OY$tZr$trs%cs#O$t#O#P%h#P;'S$t;'S;=`&f<%lO$t~%hOu~~%kRO;'S$t;'S;=`%t;=`O$t~%yXu~OY$tZr$trs%cs#O$t#O#P%h#P;'S$t;'S;=`&f;=`<%l$t<%lO$t~&iP;=`<%l$t~&qSm~OY&lZ;'S&l;'S;=`&}<%lO&l~'QP;=`<%l&l~'YO}~~'_Wu~OY'YZw'Ywx%cx#O'Y#O#P'w#P;'S'Y;'S;=`(u<%lO'Y~'zRO;'S'Y;'S;=`(T;=`O'Y~(YXu~OY'YZw'Ywx%cx#O'Y#O#P'w#P;'S'Y;'S;=`(u;=`<%l'Y<%lO'Y~(xP;=`<%l'Y~)QO$l~~)VO$n~~)[O{~R)cO&fP!OQ~)hO$m~R)oO&eP!PQ~)rP!Q![)u~)zS&g~!Q![)u!g!h*W#R#S)o#X#Y*W~*ZR{|*d}!O*d!Q![*j~*gP!Q![*j~*oQ&g~!Q![*j#R#S*d~*zO|~~+P[&g~!O!P)o!Q![+u!g!h*W#R#S,m#W#X-X#X#Y*W#[#]-p#a#b.U#g#h.x#k#l/Z#l#m0d#m#n/u~+zZ&g~!O!P)o!Q![+u!g!h*W#R#S,m#W#X-X#X#Y*W#[#]-p#a#b.U#g#h.x#k#l/Z#m#n/u~,pP!Q![,s~,xT&g~!O!P)o!Q![,s!g!h*W#R#S,m#X#Y*W~-^P&g~!Q![-a~-dS!Q![-a#[#]-p#a#b.U#g#h.x~-uP&g~!Q![-x~-{R!Q![-x#a#b.U#g#h.x~.ZQ&g~!Q![.a#g#h.s~.dR!Q![.a#a#b.m#g#h.x~.pP#g#h.s~.xO&g~~.}P&g~!Q![/Q~/TQ!Q![/Q#a#b.m~/`P&g~!Q![/c~/fT!Q![/c#W#X-X#[#]-p#a#b.U#g#h.x~/zP&g~!Q![/}~0QU!Q![/}#W#X-X#[#]-p#a#b.U#g#h.x#k#l/Z~0gR!Q![0p!c!i0p#T#Z0p~0uR&g~!Q![0p!c!i0p#T#Z0pV1VT&iS!ZR!Q![1f![!]1f!c!}1f#R#S1f#T#o1fR1kT!ZR!Q![1f![!]1f!c!}1f#R#S1f#T#o1f~2PP!U~!_!`2S~2XO!T~~2^Q$ZP!_!`2d#r#s2iQ2iO!QQ~2nO$[~~2sP!S~!_!`2v~2{O!R~~3QO$`~V3XT!ZRsS!Q![3Q![!]1f!c!}3Q#R#S3Q#T#o3Q~3mO&d~~3rO&h~~3wOx~~3zTO#S3w#S#T%c#T;'S3w;'S;=`4Z<%lO3w~4^P;=`<%l3w~4fO&j~~4kO&k~",
  tokenizers: [0, 1, 2],
  topRules: {"PromQL":[0,30],"MetricName":[1,156]},
  specialized: [{term: 57, get: (value, stack) => (specializeIdentifier(value) << 1), external: specializeIdentifier},{term: 57, get: (value, stack) => (extendIdentifier(value) << 1) | 1, external: extendIdentifier, extend: true},{term: 57, get: (value) => spec_Identifier[value] || -1}],
  tokenPrec: 0
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const inf = 161,
  nan = 162,
  Bool = 1,
  Ignoring = 2,
  On = 3,
  GroupLeft = 4,
  GroupRight = 5,
  Offset = 6,
  Atan2 = 7,
  Avg = 8,
  Bottomk = 9,
  Count = 10,
  CountValues = 11,
  Group = 12,
  Max = 13,
  Min = 14,
  Quantile = 15,
  LimitK = 16,
  LimitRatio = 17,
  Stddev = 18,
  Stdvar = 19,
  Sum = 20,
  Topk = 21,
  By = 22,
  Without = 23,
  And = 24,
  Or = 25,
  Unless = 26,
  Start = 27,
  End = 28,
  LineComment = 29,
  PromQL = 30,
  AggregateExpr = 31,
  AggregateOp = 32,
  AggregateModifier = 33,
  GroupingLabels = 34,
  LabelName = 35,
  QuotedLabelName = 36,
  StringLiteral = 37,
  FunctionCallBody = 38,
  BinaryExpr = 39,
  Pow = 40,
  BoolModifier = 41,
  MatchingModifierClause = 42,
  Mul = 43,
  Div = 44,
  Mod = 45,
  Add = 46,
  Sub = 47,
  Eql = 48,
  Gte = 49,
  Gtr = 50,
  Lte = 51,
  Lss = 52,
  Neq = 53,
  FunctionCall = 54,
  FunctionIdentifier = 55,
  AbsentOverTime = 56,
  Identifier = 57,
  Absent = 58,
  Abs = 59,
  Acos = 60,
  Acosh = 61,
  Asin = 62,
  Asinh = 63,
  Atan = 64,
  Atanh = 65,
  AvgOverTime = 66,
  Ceil = 67,
  Changes = 68,
  Clamp = 69,
  ClampMax = 70,
  ClampMin = 71,
  Cos = 72,
  Cosh = 73,
  CountOverTime = 74,
  DaysInMonth = 75,
  DayOfMonth = 76,
  DayOfWeek = 77,
  DayOfYear = 78,
  Deg = 79,
  Delta = 80,
  Deriv = 81,
  Exp = 82,
  Floor = 83,
  HistogramCount = 84,
  HistogramFraction = 85,
  HistogramQuantile = 86,
  HistogramStdDev = 87,
  HistogramStdVar = 88,
  HistogramSum = 89,
  HistogramAvg = 90,
  DoubleExponentialSmoothing = 91,
  Hour = 92,
  Idelta = 93,
  Increase = 94,
  Info = 95,
  Irate = 96,
  LabelReplace = 97,
  LabelJoin = 98,
  LastOverTime = 99,
  Ln = 100,
  Log10 = 101,
  Log2 = 102,
  MadOverTime = 103,
  MaxOverTime = 104,
  MinOverTime = 105,
  TsOfMaxOverTime = 106,
  TsOfMinOverTime = 107,
  TsOfLastOverTime = 108,
  Minute = 109,
  Month = 110,
  Pi = 111,
  PredictLinear = 112,
  PresentOverTime = 113,
  QuantileOverTime = 114,
  Rad = 115,
  Rate = 116,
  Resets = 117,
  Round = 118,
  Scalar = 119,
  Sgn = 120,
  Sin = 121,
  Sinh = 122,
  Sort = 123,
  SortDesc = 124,
  SortByLabel = 125,
  SortByLabelDesc = 126,
  Sqrt = 127,
  StddevOverTime = 128,
  StdvarOverTime = 129,
  SumOverTime = 130,
  Tan = 131,
  Tanh = 132,
  Timestamp = 133,
  Time = 134,
  Vector = 135,
  Year = 136,
  MatrixSelector = 137,
  NumberDurationLiteralInDurationContext = 138,
  NumberDurationLiteral = 139,
  OffsetExpr = 140,
  ParenExpr = 141,
  SubqueryExpr = 142,
  UnaryExpr = 143,
  UnaryOp = 144,
  VectorSelector = 145,
  LabelMatchers = 146,
  UnquotedLabelMatcher = 147,
  MatchOp = 148,
  EqlSingle = 149,
  EqlRegex = 150,
  NeqRegex = 151,
  QuotedLabelMatcher = 152,
  StepInvariantExpr = 153,
  At = 154,
  AtModifierPreprocessors = 155,
  MetricName = 156;

export { Abs, Absent, AbsentOverTime, Acos, Acosh, Add, AggregateExpr, AggregateModifier, AggregateOp, And, Asin, Asinh, At, AtModifierPreprocessors, Atan, Atan2, Atanh, Avg, AvgOverTime, BinaryExpr, Bool, BoolModifier, Bottomk, By, Ceil, Changes, Clamp, ClampMax, ClampMin, Cos, Cosh, Count, CountOverTime, CountValues, DayOfMonth, DayOfWeek, DayOfYear, DaysInMonth, Deg, Delta, Deriv, Div, DoubleExponentialSmoothing, End, Eql, EqlRegex, EqlSingle, Exp, Floor, FunctionCall, FunctionCallBody, FunctionIdentifier, Group, GroupLeft, GroupRight, GroupingLabels, Gte, Gtr, HistogramAvg, HistogramCount, HistogramFraction, HistogramQuantile, HistogramStdDev, HistogramStdVar, HistogramSum, Hour, Idelta, Identifier, Ignoring, Increase, Info, Irate, LabelJoin, LabelMatchers, LabelName, LabelReplace, LastOverTime, LimitK, LimitRatio, LineComment, Ln, Log10, Log2, Lss, Lte, MadOverTime, MatchOp, MatchingModifierClause, MatrixSelector, Max, MaxOverTime, MetricName, Min, MinOverTime, Minute, Mod, Month, Mul, Neq, NeqRegex, NumberDurationLiteral, NumberDurationLiteralInDurationContext, Offset, OffsetExpr, On, Or, ParenExpr, Pi, Pow, PredictLinear, PresentOverTime, PromQL, Quantile, QuantileOverTime, QuotedLabelMatcher, QuotedLabelName, Rad, Rate, Resets, Round, Scalar, Sgn, Sin, Sinh, Sort, SortByLabel, SortByLabelDesc, SortDesc, Sqrt, Start, Stddev, StddevOverTime, Stdvar, StdvarOverTime, StepInvariantExpr, StringLiteral, Sub, SubqueryExpr, Sum, SumOverTime, Tan, Tanh, Time, Timestamp, Topk, TsOfLastOverTime, TsOfMaxOverTime, TsOfMinOverTime, UnaryExpr, UnaryOp, Unless, UnquotedLabelMatcher, Vector, VectorSelector, Without, Year, inf, nan, parser };
